import { getDomain } from 'www/utils/get-domain';
// this is a temporary code please remove before prod release and add script in page source 
class RecapTemp {
    constructor() {}

    addFlicity() {
        let s = document.createElement("script");
            s.type = "text/javascript";
            s.src = `https://img.${getDomain()}medscapestatic.com/medscape-core/www/js/article/flickity.pkgd.min.js`;
            $("head").append(s);
    }
    createCarousel(_initialIndex = 0) {
        window.RecapFlicity = new Flickity('.recap-playlist-module ', {
            cellAlign: 'left',
            pageDots: false,
            draggable: false,
            initialIndex: _initialIndex
        });
    }
}

export {
    RecapTemp
}